import React, { FC } from 'react';

import { ErrorMessage } from 'common/components';
import { FieldError } from 'common/models';

type FieldErrorListProps = {
    field: string;
    errors: Array<FieldError>;
};

const FieldErrorList: FC<FieldErrorListProps> = ({ field, errors }: FieldErrorListProps) => {
    return (
        <>
            {errors
                .filter((item: FieldError) => item.field === field)
                .map((ele: FieldError, index: number) => (
                    <ErrorMessage key={index} message={ele.message} />
                ))}
        </>
    );
};

export default FieldErrorList;
